import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

import { CheckBulkTicketsDialogProps } from "../../../interface/dialog/CheckBulkTicketsDialogProps";
import Button from "../Button";
import { useDialogStyles } from "./styles";

const useStyles = makeStyles({
  table: {
    marginTop: 12,
  },
  headerCell: {
    fontWeight: 600,
    padding: "8px 16px",
  },
  bodyCell: {
    padding: "6px 16px",
  },
});

const CheckBulkTicketsDialog = ({
  open,
  onClose,
  onConfirmSubmit,
  response,
}: CheckBulkTicketsDialogProps) => {
  const classes = useDialogStyles();
  const localClasses = useStyles();
  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        Confirm Bulk Update
      </DialogTitle>
      {response && response.count === 0 ? (
        <DialogContent className={classes.dialogContent}>
          <Typography>
            Your selected tickets have been received. No tickets are available
            for bulk update.
          </Typography>
        </DialogContent>
      ) : (
        <>
          {response && response?.ticketNumbers?.length > 0 ? (
            <DialogContent className={classes.dialogContent}>
              <div className={classes.stackedContent}>
                <Typography>
                  <b>{response.ticketNumbers.length}</b> ticket(s) will be
                  updated.
                </Typography>
                {response.excludedTicketNumbers.length > 0 && (
                  <Typography variant="body2" className={classes.helperText}>
                    Excluded ({response.excludedTicketNumbers.length}):{" "}
                    {response.excludedTicketNumbers.join(", ")}
                  </Typography>
                )}
                {response.results.length > 0 && (
                  <TableContainer className={localClasses.table}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell className={localClasses.headerCell}>
                            Field
                          </TableCell>
                          <TableCell className={localClasses.headerCell}>
                            From
                          </TableCell>
                          <TableCell className={localClasses.headerCell}>
                            To
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {response.results.map((result, index) => (
                          <TableRow key={index}>
                            <TableCell className={localClasses.bodyCell}>
                              {result.key}
                            </TableCell>
                            <TableCell className={localClasses.bodyCell}>
                              {result.from}
                            </TableCell>
                            <TableCell className={localClasses.bodyCell}>
                              {result.to}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </div>
            </DialogContent>
          ) : (
            <DialogContent className={classes.dialogContent}>
              <Typography>No ticket conflicts were found.</Typography>
            </DialogContent>
          )}
        </>
      )}
      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            onClick={() => onClose()}
            color="default"
            variant="contained"
            type="button"
          />
        </div>
        {response && response.count > 0 && (
          <div className={classes.actionButton}>
            <Button
              label="Confirm"
              onClick={() => onConfirmSubmit()}
              autoFocus
              color="primary"
              variant="contained"
              type="button"
            />
          </div>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CheckBulkTicketsDialog;
